import { supabase } from '../supabase.js';

/** Sum of card tips on paid orders in the range. */
export async function sumPaidTips(clientId: string, start: Date, end: Date): Promise<number> {
  if (!supabase) return 0;
  let total = 0;
  for (let offset = 0; ; offset += 1000) {
    const { data, error } = await supabase
      .from('orders')
      .select('tip_amount')
      .eq('client_id', clientId)
      .eq('status', 'paid')
      .gte('paid_at', start.toISOString())
      .lte('paid_at', end.toISOString())
      .range(offset, offset + 999);
    if (error) throw new Error(error.message);
    const batch = data ?? [];
    for (const row of batch) {
      const tip = Number(row.tip_amount);
      if (tip > 0) total += tip;
    }
    if (batch.length < 1000) break;
  }
  return total;
}
